import { Box, FormControl, Grid, InputLabel, MenuItem, Paper, Select, SelectChangeEvent } from "@mui/material"
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import { LinearProgress } from "@mui/material";
import { FormHandles } from "@unform/core";

import { AlertSnackBar, AutoCompleteDeCliente, FerramentaDeDetalhe } from "../../shared/components";
import { LayoutBaseDePagina } from "../../shared/layouts";
import { VTextField, VForm, useVForm } from "../../shared/forms";
import { IndiceService } from "../../shared/services/api/indice/IndiceService";
import { Environment } from "../../shared/environment";
import { DialogConfirm } from "../../shared/components/dialog/DialogConfirm";

interface IFormData {
  nomeIndice: string;
  idComponente: number;
  cnpj: string
}

export const DetalheDeIndice: React.FC = () => {
  const { idIndice = 'novo' } = useParams<'idIndice'>();
  const navigate = useNavigate();

  const { formRef, save, saveAndReturn, isSaveAndReturn } = useVForm();

  const [cnpj, setCnpj] = useState<string | undefined | null>(undefined);

  const [alertSnackbar, setAlertSnackbar] = useState<{ tipoAlert: string, mensagem: string } | undefined>(undefined);
  const [duracaoAlert, setDuracaoAlert] = useState<number>(Environment.DURACAO_ALERT + 500);

  const [isLoading, setIsLoading] = useState(false);
  const [nomeTitulo, setNomeTitulo] = useState('');
  const [confirmar, setConfirmar] = useState(false);
  const [abrirConfirmar, setAbrirConfirmar] = useState(false);
  const [componente, setComponent] = useState('');
  const [fantasma, setFantasma] = useState('');

  const handleChange = (event: SelectChangeEvent) => {

    setFantasma(event.target.value as string)
    if (idIndice !== 'novo') {

      if (!confirmar) {

        setAbrirConfirmar(true);

      }

      if (confirmar) {

        setComponent(event.target.value as string);

      }
    } else {

      setComponent(event.target.value as string);

    }

  };

  useEffect(() => {
    if (localStorage.getItem("cnpj") === null || localStorage.getItem("cnpj") === "" || localStorage.getItem("cnpj") === undefined) {
      navigate(-1);
    } else {
      setCnpj(localStorage.getItem("cnpj"));
    }
  }, [localStorage.getItem("cnpj")]);

  useEffect(() => {
    if (idIndice !== 'novo') {
      setIsLoading(true);
      setNomeTitulo("Carregando...")

      IndiceService.getById(Number(idIndice)).then((result) => {
        setIsLoading(false);
        if (result instanceof Error) {
          setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
          setTimeout(() => {
            setAlertSnackbar(undefined);
          }, duracaoAlert);
        } else {
          setNomeTitulo(result.nomeIndice);

          formRef.current?.setData(result);
          setComponent(JSON.stringify(result.idComponente));
        }
      });
    } else {
      formRef.current?.setData({
        nomeIndice: ''
      });
      setComponent('');
    }
  }, [idIndice])


  const handleSave = (dados: IFormData) => {
    dados.idComponente = Number(componente);

    if (idIndice === 'novo') {
      if (cnpj === undefined || cnpj === null || cnpj == '') {
        setAlertSnackbar({ tipoAlert: "aviso", mensagem: "Selecione um cliente" });
        setTimeout(() => {
          setAlertSnackbar(undefined);
        }, duracaoAlert);
      } else {
        setIsLoading(true);
        dados.cnpj = cnpj;
        IndiceService.create(dados).then((result) => {
          setIsLoading(false);
          if (result instanceof Error) {
            setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
            setTimeout(() => {
              setAlertSnackbar(undefined);
            }, duracaoAlert);
          } else {
            setAlertSnackbar({ tipoAlert: "sucesso", mensagem: "Índice cadastrado" });
            setTimeout(() => {
              setAlertSnackbar(undefined);
            }, duracaoAlert);

            if (isSaveAndReturn()) {
              navigate(-1)
            } else {
              limparCampos();
            }

          }
        });
      }
    } else {
      setIsLoading(true);
      if (dados.nomeIndice == nomeTitulo) {
        // @ts-expect-error 
        delete dados.nomeIndice;
      }

      IndiceService.updateById(Number(idIndice), { idIndice: Number(idIndice), ...dados })
        .then((result) => {
          setIsLoading(false);
          if (result instanceof Error) {
            setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
            setTimeout(() => {
              setAlertSnackbar(undefined);
            }, duracaoAlert);
          } else {
            if (dados.nomeIndice !== undefined) {
              setNomeTitulo(dados.nomeIndice);
            }
            setAlertSnackbar({ tipoAlert: "sucesso", mensagem: "Indice atualizado" });
            setTimeout(() => {
              setAlertSnackbar(undefined);
            }, duracaoAlert);

            if (isSaveAndReturn()) {
              navigate(-1)
            }

          }
        });
    }
  }
  const handleDelete = () => {
    IndiceService.toggleEnabledById(Number(idIndice))
      .then(result => {
        if (result instanceof Error) {//verificar se deu erro
          setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
          setTimeout(() => {
            setAlertSnackbar(undefined);
          }, duracaoAlert);
        } else {
          setAlertSnackbar({ tipoAlert: "erro", mensagem: "Indice desativado com sucesso" });
          setTimeout(() => {
            setAlertSnackbar(undefined);
          }, duracaoAlert);
          navigate('/indice');
        }
      });
  }

  const limparCampos = () => {
    formRef.current?.setData({
      nomeIndice: ''
    });
    setComponent('');
  }

  const [abrir, setAbrir] = useState(false);

  const handleCancel = () => {
    setAbrir(false);
  };

  return (

    <LayoutBaseDePagina
      titulo={idIndice == 'novo' ? 'Novo índice' : nomeTitulo}
      barraDeFerramentas={
        <FerramentaDeDetalhe
          mostrarBotaoSalvarEVoltar
          mostrarBotaoApagar={idIndice !== 'novo'}
          mostrarBotaoNovo={idIndice !== 'novo'}

          mostrarBotaoNovoCarregando={isLoading}
          mostrarBotaoApagarCarregando={isLoading}
          mostrarBotaoSalvarCarregando={isLoading}
          mostrarBotaoSalvarEVoltarCarregando={isLoading}

          aoClicarEmSalvar={save}
          aoClicarEmSalvarEVoltar={saveAndReturn}
          aoClicarEmApagar={() => setAbrir(true)}
          aoClicarEmNovo={() => navigate('/indice/detalhe/novo')}
          aoClicarEmVoltar={() => navigate(-1)}
        />
      }
    >
      {isLoading && (
        <LinearProgress variant="indeterminate" />
      )}

      <DialogConfirm
        AoConfirmar={() => { setConfirmar(true); setAbrirConfirmar(false); setComponent(fantasma) }}
        titulo={"Dejesa realmente modificar o COMPONENTE do índice?"}
        texto={"ATENÇÃO, o índice pode apresentar comportamentos inesperados."}
        abrir={abrirConfirmar}
        AoCancelar={() => setAbrirConfirmar(false)}
      />

      <DialogConfirm
        AoConfirmar={handleDelete}
        titulo={"Dejesa realmente desativar o indice?"}
        texto={"Ao confirmar, o indice será desativado."}
        abrir={abrir}
        AoCancelar={handleCancel}
      />

      {alertSnackbar !== undefined && (
        <>
          {alertSnackbar.tipoAlert === "sucesso" && (
            <AlertSnackBar gravidade="success" mensagem={alertSnackbar.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
          )}
          {alertSnackbar.tipoAlert === "erro" && (
            <AlertSnackBar gravidade="error" mensagem={alertSnackbar.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
          )}
          {alertSnackbar.tipoAlert === "aviso" && (
            <AlertSnackBar gravidade="warning" mensagem={alertSnackbar.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
          )}
        </>
      )}

      <Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined">

        <VForm ref={formRef} onSubmit={handleSave}>
          <Grid container direction="column" padding={2} spacing={2}>

            <Grid container item direction="row" spacing={2}>

              <Grid item xs={12} sm={8} md={6} lg={4}>
                <VTextField fullWidth label="Nome" placeholder="Digite o nome..." name="nomeIndice" disabled={isLoading} />
              </Grid>

            </Grid>

            <Grid container item direction="row" spacing={2}>

              <Grid item xs={6} sm={6} md={4} lg={2}>

                <FormControl fullWidth>
                  <InputLabel id="select-component-label"> Componente </InputLabel>
                  <Select
                    labelId="select-component-label"
                    id="select"
                    label="Componente"
                    value={componente}
                    onChange={handleChange}
                    disabled={isLoading}
                  >
                    <MenuItem value={1}> Texto </MenuItem>
                    <MenuItem value={2}> Radio </MenuItem>
                    <MenuItem value={3}> Select </MenuItem>
                    <MenuItem value={4}> Marcar </MenuItem>
                    <MenuItem value={5}> Data </MenuItem>
                    <MenuItem value={6}> Período </MenuItem>
                    <MenuItem value={7}> Numérico </MenuItem>
                    <MenuItem value={8}> Intervalo Numérico </MenuItem>
                    <MenuItem value={9}> Intervalo Alfabético </MenuItem>
                    <MenuItem value={10}> CPF </MenuItem>
                    <MenuItem value={11}> CNPJ </MenuItem>
                  </Select>
                </FormControl>

              </Grid>

            </Grid>
          </Grid>
        </VForm>

      </Box>


    </LayoutBaseDePagina>
  )
}